import React from 'react';
import { motion } from 'framer-motion';
import { ButtonCTA } from './ButtonCTA';
import { ShieldCheck } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-16 md:py-24 bg-brand-sage text-white relative overflow-hidden" data-id="element-108">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 mix-blend-overlay" data-id="element-109"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10" data-id="element-110">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl text-brand-text" data-id="element-111">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-112">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="order-2 md:order-1" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/veFYusEfhhe6b3XwdnFadg/reinicio_metabolico.png" alt="Reinicio Metabólico 45+ Bundle" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-114" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="order-1 md:order-2" data-id="element-115">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-116">
                Comienza tu transformación hoy
              </h2>
              <p className="text-lg text-brand-text/80 mb-8 leading-relaxed" data-id="element-117">
                Obtén el sistema completo "Reinicio Metabólico 45+" con todas
                las guías, worksheets y el protocolo paso a paso hoy mismo.
                Recupera tu energía y tu figura por una inversión única.
              </p>

              <div className="relative bg-brand-cream p-6 rounded-2xl mb-8 text-center border border-brand-accent/50" data-id="element-118">
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-terracotta text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-119">
                  68% de descuento
                </span>
                <p className="text-sm uppercase tracking-wider text-brand-text/60 font-semibold mb-2 mt-2" data-id="element-120">
                  Precio Especial
                </p>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-121">
                  <span className="text-2xl text-brand-text/40 line-through font-medium" data-id="element-122">
                    $35.59
                  </span>
                  <span className="text-5xl font-bold text-brand-terracotta" data-id="element-123">
                    $11.39
                  </span>
                  <span className="text-2xl text-brand-text/50 self-end mb-1" data-id="element-124">
                    USD
                  </span>
                </div>
                <p className="text-sm text-brand-text/60" data-id="element-125">
                  Acceso instantáneo de por vida
                </p>
              </div>

              <div className="flex flex-col items-center gap-4" data-id="element-126">
                <ButtonCTA className="w-full text-center justify-center py-5 text-xl" data-id="element-127">
                  ¡SÍ, QUIERO MI REINICIO AHORA!
                </ButtonCTA>
                <div className="flex items-center gap-2 text-sm text-brand-text/60" data-id="element-128">
                  <ShieldCheck className="w-4 h-4 text-brand-sage" data-id="element-129" />
                  <span data-id="element-130">Acceso instantáneo después de tu compra segura.</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}